/**
 * Seconds between email-code resend requests. Enforced on the BE in
 *  MfaManager.resendEmailForLogin; the FE counts down the same value.
 */
export const EMAIL_RESEND_COOLDOWN_SECONDS = 60;

/**
 * Exact error messages thrown by MfaManager. The FE matches on these verbatim
 *  to decide UX: the session-ended set (noActiveSession / sessionExpired /
 *  tooManyAttempts) means the pending challenge is dead and the user must
 *  restart; invalidCode means the entered code was wrong and can be retried.
 */
export const MFA_ERROR_MESSAGES = {
  noActiveSession: 'No active MFA session. Please log in again.',
  sessionExpired: 'MFA session expired. Please log in again.',
  tooManyAttempts: 'Too many failed MFA attempts. Please log in again.',
  invalidCode: 'Invalid MFA code',
  invalidBackupCode: 'Invalid backup code',
} as const;

const SESSION_ENDED_MESSAGES = [
  MFA_ERROR_MESSAGES.noActiveSession,
  MFA_ERROR_MESSAGES.sessionExpired,
  MFA_ERROR_MESSAGES.tooManyAttempts,
] as const;

export const isMfaSessionEnded = (message: string): boolean =>
  SESSION_ENDED_MESSAGES.some((m) => m === message);
